/**
 * Link tools.
 */
H_Tools.links = (() => {
    // console.log('Link tools initialized');

    /**
     * Add the supplied text to the title of the supplied element.
     *
     * The elements previous title is preserved and this new text is appended to the end
     * of the previous description.
     *
     * @param el   An element
     * @param text The text to append to the element's title
     */
    function append_aria_description(el, text) {
        let old = el.getAttribute('title');
        el.setAttribute('title', old ? old + ', ' + text : text);
    }

    /**
     * Modify all links inside the supplied element to include aria-descriptions for screen readers
     * when the link opens in a new window and when the link leads to a different site.
     *
     * Representative modifier classes are also added for in these cases.
     *
     * @param {*} el The element to process
     */
    function modifyLinks(el) {
        let links = el.querySelectorAll('a[href]');

        if (!links.length) {
            return;
        }

        links.forEach((link) => {
            // console.log('link', link);

            if (
                link.href.startsWith('sms:') ||
                link.href.startsWith('tel:') ||
                link.href.startsWith('mailto:') ||
                link.href.startsWith('javascript:') // jshint ignore:line
            ) {
                return;
            }

            // Links that open in a new tab
            if (link.target === '_blank') {
                link.classList.add('-opens-in-new-tab');
                append_aria_description(link, window.new_tab_description);
            }

            // External links
            if (link.hostname !== window.location.hostname) {
                link.classList.add('-external');
                append_aria_description(link, window.external_link_description);
            }
        });
    }

    // Return an object to expose inner functions
    return {
        modifyLinks: modifyLinks,
    };
})();
